import { createBrowserRouter, Navigate } from "react-router-dom";
import ChooseAccountType from "../../scenes/complete-profile/account-type/ChooseAccountType";
import ChoosePracticedSport from "../../scenes/complete-profile/old/ChoosePracticedSport/ChoosePracticedSport";
import ChooseSportsOfInterest from "../../scenes/complete-profile/old/ChooseSportsOfInterest/ChooseSportsOfInterest";
import CompleteProfileBio from "../../scenes/complete-profile/old/CompleteProfileBio/CompleteProfileBio";
import CompleteProfileLocation from "../../scenes/complete-profile/old/CompleteProfileLocation/CompleteProfileLocation";
import CompleteProfileYears from "../../scenes/complete-profile/old/CompleteProfileYears/CompleteProfileYears";
import CompleteProfileData from "../../scenes/complete-profile/profile-data/CompleteProfileData";
import Login from "../../scenes/login/Login";
import RecoverPasswordRequest from "../../scenes/recover-password/RecoverPasswordRequest";
import RecoverRequestConfirmation from "../../scenes/recover-password/RecoverRequestConfirmation";
import EmailVerification from "../../scenes/SignUp/email-verification/EmailVerification";
import SetPassword from "../../scenes/SignUp/SetPassword/SetPassword";
import SignUp from "../../scenes/SignUp/SignUp";
import SignUpConfirmation from "../../scenes/SignUp/SignUpConfirmation/SignUpConfirmation";
import SignUpEmail from "../../scenes/SignUp/SignUpEmail/SignUpEmail";
import Success from "../../scenes/SignUp/Success/Success";
import PublicRouteComponent from "./PublicRouteComponent";

const signUpRoutes = [
  {
    path: "email",
    element: <SignUpEmail />,
  },
  {
    path: "code",
    element: <SignUpConfirmation />,
  },
  {
    path: "email-verification",
    element: <EmailVerification />,
  },
  {
    path: "password",
    element: <SetPassword context="set" />,
  },
  {
    path: "password-recovery",
    children: [
      {
        path: "email",
        element: <RecoverPasswordRequest />,
      },
      {
        path: "confirm",
        element: <RecoverRequestConfirmation />,
      },
      {
        path: "password",
        element: <SetPassword context="recover" />,
      },
    ],
  },

  {
    path: "info",
    element: <CompleteProfileData />,
  },
  {
    path: "bio",
    element: <CompleteProfileBio />,
  },
  {
    path: "location",
    element: <CompleteProfileLocation />,
  },
  {
    path: "years",
    element: <CompleteProfileYears />,
  },
  {
    path: "type",
    element: <ChooseAccountType />,
  },
  {
    path: "practiced-sport",
    element: <ChoosePracticedSport />,
  },
  {
    path: "other-sports",
    element: <ChooseSportsOfInterest />,
  },
  {
    path: "success",
    element: <Success isProfile={false} />,
  },
];

const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicRouteComponent />,
    children: [
      {
        path: "/",
        element: <Navigate to="/login" />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
        children: signUpRoutes,
      },
      {
        path: "*",
        element: <Navigate to="/login" />,
      },
    ],
  },
]);

export default router;
